/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderResponse } from './LadderResponse';
import {
    LadderResponseFromJSON,
    LadderResponseFromJSONTyped,
    LadderResponseToJSON,
    LadderResponseToJSONTyped,
} from './LadderResponse';

/**
 * 
 * @export
 * @interface GetPublicLadderResponse
 */
export interface GetPublicLadderResponse {
    /**
     * 
     * @type {LadderResponse}
     * @memberof GetPublicLadderResponse
     */
    ladder: LadderResponse;
}

/**
 * Check if a given object implements the GetPublicLadderResponse interface.
 */
export function instanceOfGetPublicLadderResponse(value: object): value is GetPublicLadderResponse {
    if (!('ladder' in value) || value['ladder'] === undefined) return false;
    return true;
}

export function GetPublicLadderResponseFromJSON(json: any): GetPublicLadderResponse {
    return GetPublicLadderResponseFromJSONTyped(json, false);
}

export function GetPublicLadderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPublicLadderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ladder': LadderResponseFromJSON(json['ladder']),
    };
}

export function GetPublicLadderResponseToJSON(json: any): GetPublicLadderResponse {
    return GetPublicLadderResponseToJSONTyped(json, false);
}

export function GetPublicLadderResponseToJSONTyped(value?: GetPublicLadderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ladder': LadderResponseToJSON(value['ladder']),
    };
}

